import { Grid } from '@material-ui/core';
import { Heading, Button, ExtendedTheme } from 'neon-design-system';
import { createStyles, makeStyles } from '@material-ui/styles';

interface Props {
  title: string;
  buttonLabel?: string;
  secondaryButtonLabel?: string;
  onClick?: () => void;
  secondaryButtonOnClick?: () => void;
  belowHeading?: React.ReactNode;
  rightToolbar?: React.ReactNode;
  leftToolbar?: React.ReactNode;
  actions?: React.ReactNode;
}

const useStyles = makeStyles((theme: ExtendedTheme) =>
  createStyles({
    header: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    select: {
      width: 320
    },
    secondaryButton: {
      marginLeft: theme.spacing(1)
    }
  })
);

export const PageHeader = ({
  title,
  buttonLabel,
  onClick,
  belowHeading,
  leftToolbar,
  rightToolbar,
  actions,
  secondaryButtonLabel,
  secondaryButtonOnClick
}: Props) => {
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} className={classes.header}>
        <Heading styleName="title1">{title}</Heading>
        {actions}
        {(buttonLabel || secondaryButtonLabel) && (
          <div>
            <Button colorType="primary" onClick={onClick}>
              {buttonLabel}
            </Button>
            {secondaryButtonLabel && (
              <Button colorType="grey" onClick={secondaryButtonOnClick} className={classes.secondaryButton}>
                {secondaryButtonLabel}
              </Button>
            )}
          </div>
        )}
      </Grid>
      {belowHeading && (
        <Grid item xs={12}>
          {belowHeading}
        </Grid>
      )}
      {(leftToolbar || rightToolbar) && (
        <Grid item xs={12}>
          <Grid container justifyContent="space-between">
            <Grid item xs={6}>
              {leftToolbar}
            </Grid>
            <Grid container item xs={6} justifyContent="flex-end">
              {rightToolbar}
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};
